import { ColorSamplePurpose, ColorSampleResult } from "@/core/color-sampler"
import { atom } from "jotai"

export interface ColorPickerSession {
	purpose: ColorSamplePurpose
	handler: (result: ColorSampleResult) => boolean
}

export const colorPickerSessionAtom = atom<ColorPickerSession | null>(null)
